const OfflineBanner = (): JSX.Element => {
  return <div className="sw_popup_offline" id="sw-toast-offline"></div>;
};

export default OfflineBanner;
